import { Select, Text, VStack } from '@genial/components';
import React from 'react';

interface Option {
  label: string;
  value: string;
}

export interface PartnerSelectProps {
  options: Option[];
  selectedPartner?: number;
  disabled: boolean;
  onChange: (partnerId: number) => void;
}

export const PartnerSelect: React.FC<PartnerSelectProps> = ({
  options,
  selectedPartner,
  disabled,
  onChange,
}) => {
  return (
    <VStack space="inline.xxxs" zIndex={2}>
      <Text variant="semibold">Seleção de filial</Text>
      <Select
        maxOptionPerRender={10}
        triggerProps={{ bg: 'background' }}
        placeholder="Selecione uma filial"
        options={options}
        selectedValue={selectedPartner?.toString()}
        onValueChange={(value) => onChange(Number(value))}
        disabled={disabled}
      />
    </VStack>
  );
};
